import React, { useState } from "react";
import { DatePicker, Select, Button } from "antd";
import { useSelector } from "react-redux";

const { Option } = Select;

const Filter = ({ selectedFile, setSelectedFile }) => {
  const [dropdown1Value, setDropdown1Value] = useState(null);
  const [dropdown2Value, setDropdown2Value] = useState(null);
  const [billerId, setBillerId] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  const { fetchData } = useSelector((state) => {
    return {
      fetchData: state?.fetch,
    };
  });

  // Handlers
  const handleDropdown1Change = (value) => {
    setDropdown1Value(value);
    // setFormData({
    //   ...formData,
    //   fileType: value
    // })
  };
  const handleDropdown2Change = (value) => {
    setDropdown2Value(value);
    // setFormData({
    //   ...formData,
    //   cycleNo: value
    // })
  };
  const handleChangeBillerId = (value) => {
    setBillerId(value);
  };
  const handleDateChange = (date, dateString) => {
    setSelectedDate(dateString);
    // setFormData({
    //   ...formData,
    //   date: dateString
    // })
  };

  const handleFormSubmit = () => {
    if (dropdown1Value && dropdown2Value && selectedDate) {
      setSelectedFile({
        cycleNo: dropdown2Value,
        fileType: dropdown1Value,
        billerId: billerId,
        date: selectedDate,
      });
    } else {
      console.log("Please fill in all fields.");
    }
  };

  const billerIds = [
    {
      name: "Aye Finance Private Limited",
      id: "AYEF00000NATZB",
    },
    {
      name: "Annapurna Finance Private Limited",
      id: "ANNA00000NATUO",
    },
    {
      name: "Nagar Nigam Saharanpur",
      id: "NAGA00000SAHTD",
    },
    {
      name: "Repco Micro Finance",
      id: "REPC00000NATP7",
    },
    {
      name: "Svakarma",
      id: "SVAK00000NATBW",
    },
  ];

  return (
    <div className="flex items-center gap-4 px-4 py-2">
      {/* Dropdown 1 */}
      <Select
        suffixIcon={<span className="text-lg text-red-500">*</span>}
        placeholder="Select File Type"
        className="w-48"
        onChange={handleDropdown1Change}
        value={dropdown1Value}
      >
        <Option value="XML">XML File</Option>
        <Option value="JSON">JSON File</Option>
        <Option value="Match">MATCH File</Option>
        <Option value="Match_Internal">MATCH Internal File</Option>
        <Option value="Unmatch">UNMATCH File</Option>
        <Option value="Unmatch_Internal">UNMATCH Internal File</Option>
        <Option value="SAL_File">SAL File</Option>
        <Option value="Transaction_Report">Transaction Report</Option>
        <Option value="None">None</Option>
      </Select>

      {/* Dropdown 2 */}
      <Select
        suffixIcon={<span className="text-lg text-red-500">*</span>}
        placeholder="Select Cycle No."
        className="w-48"
        onChange={handleDropdown2Change}
        value={dropdown2Value}
      >
        {[...Array(8)].map((_, i) => (
          <Option key={i} value={i + 1}>
            Cycle {i + 1}
          </Option>
        ))}
      </Select>

      {/* Dropdown 3 */}
      <Select
        placeholder="Select Biller Id."
        className="w-48"
        onChange={handleChangeBillerId}
        value={billerId}
      >
        <Option value="">Select Biller Id</Option>
        {billerIds?.map((item, index) => (
          <Option key={item} value={item.id}>
            {item.name}
          </Option>
        ))}
      </Select>

      {/* Date Picker */}
      <DatePicker
        suffixIcon={<span className="text-lg text-red-500">*</span>}
        className="w-48"
        onChange={handleDateChange}
        placeholder="Select a date"
      />

      {/* Submit Button */}
      <Button
        type="primary"
        onClick={handleFormSubmit}
        disabled={
          dropdown1Value && dropdown2Value && selectedDate ? false : true
        }
        className="bg-blue-500 text-white hover:bg-blue-600"
      >
        Submit
      </Button>
    </div>
  );
};

export default Filter;
